import React from 'react'

import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { IntegrationCredentialForm } from '@/views/Organizations/components/IntegrationCredentialForm'

export const ManageIntegrationCredentialsButton = ({ organizationId }) => {
  return (
    <ButtonAndFormModal
      buttonLabel="Manage Integration Credentials"
      modalTitle="Manage Integration Credentials"
      modalId="manage-integration-credentials"
      modalProps={{ size: 'small' }}
      buttonProps={{ primary: true }}
      form={<IntegrationCredentialForm organizationId={organizationId} />}
    />
  )
}
